<div class="flex flex-grow justify-center my-4">
  <fuse-alert [appearance]="'soft'" [type]="'warn'">
    <mat-icon class="icon-size-{{ iconSize }}" fuseAlertIcon [svgIcon]="icon">
    </mat-icon>
    <span fuseAlertTitle ngIf="title !== null && title.length > 0">{{ title }}</span>
    {{ message }}
  </fuse-alert>
</div>
